module.exports = __webpack_public_path__ + "static/media/yy6.a1ec0a27.png";